// extracted by mini-css-extract-plugin
export default {"mappingChanged":"UnifiedAttributeMappingStatus-module__mappingChanged___BOI8z"};